import { render, staticRenderFns } from "./BindScanCupboard.vue?vue&type=template&id=6aa94dee&scoped=true&"
import script from "./BindScanCupboard.vue?vue&type=script&lang=js&"
export * from "./BindScanCupboard.vue?vue&type=script&lang=js&"
import style0 from "./BindScanCupboard.vue?vue&type=style&index=0&id=6aa94dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa94dee",
  null
  
)

export default component.exports